<template>
  <div>
    <div>
      <b-container>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card no-body class="overflow-hidden mt-2" @click="toApplyCard()">
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/DubaiDIY/img_apply_xy.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6>
                          <b>Upload your picture</b>
                        </h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">Apply</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="toSelectApplyCard()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/DubaiDIY/宠物/公司展会DIY卡-05.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>Choose the picture</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass" @click=""
                      >Apply</b-button
                    >
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="toQueryOrder()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/DubaiDIY/img_query_xy.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>Progress query</b></h6>
                      </b-col>
                    </b-row>
                    <b-button
                      variant="danger"
                      class="btnClass"
                      @click="queryOrder_Dubai()"
                      >Query</b-button
                    >
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home_Dubai",
  data() {
    return {};
  },
  methods: {
    // 申请卡片
    toApplyCard() {
      this.$router.push({
        name: "ApplyCard_Dubai",
        params: {
          stats: "DIY"
        }
      });
    },
    toSelectApplyCard() {
      this.$router.push({
        name: "ApplyCard_Dubai",
        params: {
          stats: "SElE_DIY"
        }
      });
    },
    queryOrder_Dubai() {
      this.$router.push({
        name: "QueryOrder_Dubai"
      });
    },
    toQueryOrder() {}
  }
};
</script>
<style scoped>
.img {
  width: 100vw;
}

.btnClass {
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/Home_Dubai.vue